<div class="menuTriger" id="headTriger">
    <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffectj (click)="showHeader()">
        <i class="fa fa-arrow-up" id="headTrigerIcon"></i>
    </a>
</div>


<div class="col-md-12 mb-5">

    <div class="card py-3">
        <!-- Mobile view -->
        <div class="d-block d-md-none">
            <div class="container">
                <mdb-select (ngModelChange)="getSelectedGroupValue($event)" [(ngModel)]="selectedGroup"
                    [options]="groupSelect" placeholder="Choose group" label="Group"></mdb-select>
            </div>
            <br />
            <div class="container">
                <mdb-date-picker (ngModelChange)="getSelectedDateValue($event)" [inline]="true" name="mydate"
                    [options]="datePickerOptions" [placeholder]="'Selected date'" [(ngModel)]="selectedDate"
                    label="Date">
                </mdb-date-picker>
            </div>
            <br />
            <div class="container">
                <mdb-select (ngModelChange)="getSelectedTimePeriodValue($event)" [(ngModel)]="selectedPeriod"
                    [options]="periodSelect" placeholder="Choose periods" label="Periods">
                </mdb-select>
            </div>
            <div class="container">
                <div class="row">
                    <div class="mx-auto">
                        <a class="btn btn-outline-primary waves-effect btn-sm button-style" (click)="goPrevDay();">Prev
                            Day</a>
                    </div>
                    <div class="mx-auto">
                        <a class="btn btn-outline-primary waves-effect btn-sm button-style" (click)="goNextDay();">Next
                            Day</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- Desktop view -->
        <div class="d-none d-md-block">
            <div class="row">
                <div class="col-md-1 mx-auto">
                    <a class="btn btn-outline-primary waves-effect btn-sm button-style" (click)="goPrevDay();">Prev
                        Day</a>
                </div>
                <div class="col-md-3 mx-auto">
                    <mdb-select (ngModelChange)="getSelectedGroupValue($event)" [(ngModel)]="selectedGroup"
                        [options]="groupSelect" placeholder="Choose group" label="Group"></mdb-select>
                </div>
                <div class="col-md-3 mx-auto">
                    <mdb-date-picker (ngModelChange)="getSelectedDateValue($event)" [inline]="true" name="mydate"
                        [options]="datePickerOptions" [placeholder]="'Selected date'" [(ngModel)]="selectedDate"
                        label="Date"></mdb-date-picker>
                </div>
                <div class="col-md-3 mx-auto">
                    <mdb-select (ngModelChange)="getSelectedTimePeriodValue($event)" [(ngModel)]="selectedPeriod"
                        [options]="periodSelect" placeholder="Choose periods" label="Periods"></mdb-select>
                </div>
                <div class="col-md-1 mx-auto">
                    <a class="btn btn-outline-primary waves-effect btn-sm button-style" (click)="goNextDay();">Next
                        Day</a>
                </div>
            </div>
        </div>
    </div>
    <br />
    <div class="row">
        <div class="col-md-6 mb-5">
            <div *ngIf='(viewWeatherState$ | async) as w'>
                <div class="card card-cascade narrower">
                    <mdb-card>
                        <mdb-body>
                            <div
                                class="view view-cascade gradient-card-header blue-gradient narrower py-1 mx-4 mb-3 d-flex justify-content-between align-items-center">
                                <div class="col-md-4"></div>
                                <div class="col-md-4 board-name">Weather</div>
                                <div class="col-md-4"></div>
                            </div>
                            <div *ngIf='w.isLoading'>
                                <div class="mt-5 text-center h1-responsive">
                                    <p>Loading Weather Data...</p>
                                </div>
                                <div class="mt-5 text-center">
                                    <mdb-spinner spinnerType="big" spinnerColor="blue"></mdb-spinner>
                                </div>
                            </div>
                            <div *ngIf='w.isNotFound && w.isLoaded'>
                                <div class="alert alert-info col-md-10 mx-auto" role="alert">
                                    <div class="text-center">
                                        <h3><strong>The Weather Data is Currently not Available</strong>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf='!w.isNotFound'>
                                <!-- Mobile view -->
                                <div class="d-block d-md-none">
                                    <div class="table-responsive">
                                        <table class="table" mdbTable small="true" hover="true">
                                            <tbody>
                                                <tr (click)="triggerExtendedView();">
                                                    <td><img src="./../images/weather-{{w.DayIcon}}.png"
                                                            alt="{{w.DayIconPhrase}}"></td>
                                                    <td>{{w.DayWeatherText}}<br />{{w.TemperatureMaxValue}}{{w.TemperatureMaxUnit}}
                                                    </td>
                                                </tr>
                                                <tr (click)="triggerExtendedView();">
                                                    <td><img src="./../images/weather-{{w.NightIcon}}.png"
                                                            alt="{{w.NightIconPhrase}}"></td>
                                                    <td>{{w.NightWeatherText}}<br />{{w.TemperatureMinValue}}{{w.TemperatureMinUnit}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div *ngIf='extendWeather'>
                                        <br />
                                        <div class="table-responsive">
                                            <table class="table" mdbTable small="true" hover="false">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2">Day</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2">{{w.DayLongPhrase}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Precipitation</td>
                                                        <td>{{w.DayPrecipitationProbability}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Precipitation</td>
                                                        <td>{{w.DayTotalPrecipitation}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Rain</td>
                                                        <td>{{w.DayTotalRain}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Snow</td>
                                                        <td>{{w.DayTotalSnow}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Ice</td>
                                                        <td>{{w.DayTotalIce}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Cloud Cover</td>
                                                        <td>{{w.DayCloudCover}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Wind</td>
                                                        <td>{{w.DayWind}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Gusts</td>
                                                        <td>{{w.DayWindGust}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <br />
                                        <div class="table-responsive">
                                            <table class="table" mdbTable small="true" hover="false">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2">Night</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2">{{w.NightLongPhrase}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Precipitation</td>
                                                        <td>{{w.NightPrecipitationProbability}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Precipitation</td>
                                                        <td>{{w.NightTotalPrecipitation}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Rain</td>
                                                        <td>{{w.NightTotalRain}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Snow</td>
                                                        <td>{{w.NightTotalSnow}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Ice</td>
                                                        <td>{{w.NightTotalIce}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Cloud Cover</td>
                                                        <td>{{w.NightCloudCover}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Wind</td>
                                                        <td>{{w.NightWind}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Gusts</td>
                                                        <td>{{w.NightWindGust}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="container">
                                            <div class="col-md-12 weather-site-link">
                                                <a href="{{w.Link}}" target="_blank"><span
                                                        style="font-size: small;">{{w.Sources}}...</span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Desktop view -->
                                <div class="d-none d-md-block">
                                    <div class="card-body card-body-cascade card-body-top-pos">
                                        <div class="row" (click)="triggerExtendedView();">
                                            <div class="col-md-6">
                                                <div class="row">
                                                    <div class="col-md-2"><img
                                                            src="./../images/weather-{{w.DayIcon}}.png"
                                                            alt="{{w.DayIconPhrase}}"></div>
                                                    <div class="col-md-10"><span
                                                            class="weather-text">{{w.DayWeatherText}}<br />{{w.TemperatureMaxValue}}{{w.TemperatureMaxUnit}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="row">
                                                    <div class="col-md-2"><img
                                                            src="./../images/weather-{{w.NightIcon}}.png"
                                                            alt="{{w.NightIconPhrase}}"></div>
                                                    <div class="col-md-10"><span
                                                            class="weather-text">{{w.NightWeatherText}}<br />{{w.TemperatureMinValue}}{{w.TemperatureMinUnit}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf='extendWeather'>
                                        <div class="col-md-5 extend-weather-day">

                                            <div class="card card-body">
                                                <div class="table-responsive">
                                                    <table class="table" mdbTable small="true" hover="false">
                                                        <tbody>
                                                            <tr>
                                                                <td colspan="2">{{w.DayLongPhrase}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Precipitation</td>
                                                                <td>{{w.DayPrecipitationProbability}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Total Precipitation</td>
                                                                <td>{{w.DayTotalPrecipitation}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Rain</td>
                                                                <td>{{w.DayTotalRain}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Snow</td>
                                                                <td>{{w.DayTotalSnow}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Ice</td>
                                                                <td>{{w.DayTotalIce}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Cloud Cover</td>
                                                                <td>{{w.DayCloudCover}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Wind</td>
                                                                <td>{{w.DayWind}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Gusts</td>
                                                                <td>{{w.DayWindGust}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-1"></div>
                                        <div class="col-md-5 extend-weather-night">
                                            <div class="card card-body">
                                                <div class="table-responsive">
                                                    <table class="table" mdbTable small="true" hover="false">
                                                        <tbody>
                                                            <tr>
                                                                <td colspan="2">{{w.NightLongPhrase}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Precipitation</td>
                                                                <td>{{w.NightPrecipitationProbability}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Total Precipitation</td>
                                                                <td>{{w.NightTotalPrecipitation}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Rain</td>
                                                                <td>{{w.NightTotalRain}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Snow</td>
                                                                <td>{{w.NightTotalSnow}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Ice</td>
                                                                <td>{{w.NightTotalIce}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Cloud Cover</td>
                                                                <td>{{w.NightCloudCover}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Wind</td>
                                                                <td>{{w.NightWind}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Gusts</td>
                                                                <td>{{w.NightWindGust}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="container">
                                            <div class="col-md-12 weather-site-link">
                                                <a href="{{w.Link}}" target="_blank"><span
                                                        style="font-size: small;">{{w.Sources}}...</span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mdb-body>
                    </mdb-card>
                </div>
            </div>
            <br />
            <div *ngIf='(viewState$ | async) as a'>
                <div *ngIf='a.isLoading'>
                    <div class="mt-5 text-center h1-responsive">
                        <p>Loading Alerts Data...</p>
                    </div>
                    <div class="mt-5 text-center">
                        <mdb-spinner spinnerType="big" spinnerColor="blue"></mdb-spinner>
                    </div>
                </div>
                <div class="card card-cascade narrower">
                    <mdb-card>
                        <mdb-body>
                            <div
                                class="view view-cascade gradient-card-header blue-gradient narrower py-1 mx-4 mb-3 d-flex justify-content-between align-items-center">
                                <div class="col-md-4 last-update-date">{{a.LastUpdated}}</div>
                                <div class="col-md-4 board-name">{{a.name}}</div>
                                <div class="col-md-4"></div>
                            </div>
                            <div class="card-body card-body-cascade card-body-top-pos">
                                <canvas mdbChart [chartType]="chartType" [datasets]="a.alerts" [labels]="a.chartLabels"
                                    [colors]="chartColors" [options]="chartOptions" [legend]="true"
                                    (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)">
                                </canvas>
                            </div>
                        </mdb-body>
                    </mdb-card>
                </div>
            </div>
        </div>
        <div class="col-md-6 mb-5">
            <div *ngIf='(viewHistState$ | async) as h'>
                <div class="card card-cascade narrower">
                    <mdb-card>
                        <mdb-body>
                            <div
                                class="view view-cascade gradient-card-header blue-gradient narrower py-1 mx-4 mb-3 d-flex justify-content-between align-items-center">
                                <div class="col-md-3 last-update-date">{{h.LastUpdated}}</div>
                                <div class="col-md-6 board-name">Alert History<span class="filter-times"
                                        *ngIf='filterTimes?.length'> ({{filterTimes}})</span></div>
                                <div class="col-md-3"></div>
                            </div>
                            <div *ngIf='h.isLoading'>
                                <div class="mt-5 text-center h1-responsive">
                                    <p>Loading Weather Data...</p>
                                </div>
                                <div class="mt-5 text-center">
                                    <mdb-spinner spinnerType="big" spinnerColor="blue"></mdb-spinner>
                                </div>
                            </div>
                            <div *ngIf='h.isNotFound && h.isLoaded'>
                                <div class="alert alert-info col-md-10 mx-auto" role="alert">
                                    <div class="text-center">
                                        <h3><strong>The History Data is Currently not Available</strong>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf='!h.isNotFound'>
                                <div class="card-body card-body-cascade card-body-top-pos">
                                    <div class="table-responsive" *ngIf='!h.isNotFound'>
                                        <table class="table" mdbTable small="true" hover="true">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Start</th>
                                                    <th>End</th>
                                                    <th>Duration</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let ah of h.alerts | slice:0:maximumHistoryAlerts;"
                                                    (click)="showDetails(ah.CorrelationId);">
                                                    <td [ngClass]="{'danger-cell' : ah.IsAlertActive}"><span
                                                            class="history-table-text">{{ah.SkillsetName}}</span>
                                                    </td>
                                                    <td><span class="history-table-text">{{ah.BeginTime}}</span></td>
                                                    <td><span class="history-table-text">{{ah.EndTime}}</span></td>
                                                    <td><span class="history-table-text">{{ah.AlertDuration}}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div *ngIf='h.alerts?.length > 3' class="container">
                                            <div class="row">
                                                <div class="col-md-4">
                                                </div>
                                                <div class="col-md-4 footer-record-count">
                                                    <span class="footer-text">{{historyListCountText}}</span>
                                                </div>
                                                <div class="col-md-4 footer-button">
                                                    <a (click)="triggerAlertHistoryRows();"><span
                                                            class="footer-text">{{historyListButtonText}}</span></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mdb-body>
                    </mdb-card>
                </div>
            </div>
        </div>
    </div>